var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boolean_question",class:{ faded: _vm.is_loading }},[_c('div',{staticClass:"relative"},[(_vm.is_loading)?_c('div',{staticClass:"loading absolute center"}):_vm._e(),_c('checkbox',{attrs:{"checked":_vm.isChecked},on:{"input":_vm.updateQuestionAnswer}},[_vm._v(_vm._s(_vm.question.designator))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }